import { useState, useRef } from 'react'

export function useDebouncedFilter(delay = 300) {
  const [filter, setFilter] = useState("");
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setFilter(e.target.value);
    }, delay);
  };

  return { filter, onChange };
}